<template>
  <!--  园区概况-->
  <div class="over">
    <Title :info="energyTitle"/>
    <div class="energy">
      <div class="box" v-for="(item,i) in energyList" :key="i">
        <div class="energy-box">
          <div class="circle-ico"></div>
          <div class="ico" :style="'background: url('+item.ico+')'"></div>
        </div>
        <p>{{item.text}}</p>
        <div class="energy-num">{{item.num}}</div>
      </div>
    </div>
    <Title :info="personnelTitle"/>
    <div class="personnel" ref="personnelEcharts"></div>
    <Title :info="alarmTitle"/>
    <div class="alarm-box">
      <ul class="alarm-list">
        <li>
          <div class="list-top">
            <div class="degree-color"></div>
            <span>一般</span>
            <span>设备维修</span>
            <span>2022-08-05 15:23:44</span>
          </div>
          <div class="list-bottom">
            <span>9F强电井</span>
            <p>来返单</p>
          </div>
        </li>
        <li>
          <div class="list-top">
            <div class="degree-color"></div>
            <span>一般</span>
            <span>设备维修</span>
            <span>2022-08-05 15:23:44</span>
          </div>
          <div class="list-bottom">
            <span>9F强电井</span>
            <p>来返单</p>
          </div>
        </li>
        <li>
          <div class="list-top">
            <div class="degree-color" style="background: red"></div>
            <span>严重</span>
            <span>设备维修</span>
            <span>2022-08-05 15:23:44</span>
          </div>
          <div class="list-bottom">
            <span>9F强电井</span>
            <p>来返单</p>
          </div>
        </li>
      </ul>
    </div>
    <Title :info="monitorTitle"/>
    <ul class="monitor">
      <li>
        <span>监控1</span>
        <video src="../video/1.mp4" class="bg" muted autoplay controls loop></video>
      </li>
      <li>
        <span>监控1</span>
        <video src="../video/2.mp4" class="bg" muted autoplay controls loop></video>
      </li>
      <li>
        <span>监控1</span>
        <video src="../video/3.mp4" class="bg" muted autoplay controls loop></video>
      </li>
      <li>
        <span>监控1</span>
        <video src="../video/4.mp4" class="bg" muted autoplay controls loop></video>
      </li>
    </ul>
  </div>
</template>

<script>
  import Title from "@/components/Title";
  import {personnel} from "../../public/utils/echarts";
  import {EleResize} from "../../public/utils/esresize";
  export default {
    name: 'HomeView',
    components: {
      Title
    },
    data() {
      return {
        energyList: [
          {
            ico: require('./../assets/water.png'),
            text: '水(kw)',
            num: "4200"
          }, {
            ico: require('./../assets/lightning.png'),
            text: '电(吨)',
            num: "50"
          }, {
            ico: require('./../assets/natural-gas.png'),
            text: '气（立方）',
            num: "458"
          }
        ],
        energyTitle: {
          ico: require('./../assets/monitoring.png'),
          text: '能耗检测',
          english: 'Energy consumption monitoring',
          width: 16,
          height: 16
        },
        personnelTitle: {
          ico: require('./../assets/personnel.png'),
          text: '人员统计',
          english: 'Personnel statistics',
          width: 18,
          height: 19
        },
        alarmTitle: {
          ico: require('./../assets/alarm.png'),
          text: '告警信息',
          english: 'Alarm information',
          width: 20,
          height: 18
        },
        monitorTitle:{
          ico: require('./../assets/monitor.png'),
          text: '重点监控',
          english: 'Focused monitoring',
          width: 19,
          height: 16
        },
      }
    },
    mounted() {
      this.drawLine1();
      var height1 = window.screen.height
      var height2 = document.body.clientHeight

      for (let i = 0; i < document.querySelectorAll('.energy-box').length; i++) {
        document.querySelectorAll('.energy-box')[i].style.transform = 'scale(' + height2 / height1 + ')';
      }
      window.addEventListener('resize', () => {
        var height = document.body.clientHeight
        for (let i = 0; i < document.querySelectorAll('.energy-box').length; i++) {
          document.querySelectorAll('.energy-box')[i].style.transform = 'scale(' + height / height1 + ')';
        }
      })

    },
    methods:{
      drawLine1() {
        let option = personnel();
        let myChart = this.$echarts.init(this.$refs.personnelEcharts);
        myChart.setOption(option);
        let listener = function() {
          myChart.resize();
        };
        EleResize.on(this.$refs.personnelEcharts, listener);
      },
    }
  }
</script>
<style scoped lang="less">
  .over {
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 12px;

    .energy {
      width: 100%;
      height: 120vh*0.0926;
      overflow: hidden;
      padding: 0 9px;
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      margin-top: 14vh*0.0926;
      margin-bottom: 24vh*0.0926;
      .box {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        justify-content: space-between;
        &:last-of-type {
          .energy-box {
            &:after {
              display: none;
            }
          }
        }

        .energy-box {
          background: url("./../assets/circle.png") no-repeat;
          background-size: 100% 100%;
          width: 78px;
          height: 78px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          &:after {
            content: '';
            display: block;
            background: url("./../assets/division.png") no-repeat;
            background-size: 100% 100%;
            width: 26px;
            height: 5px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 91px;
          }

          .circle-ico {
            position: absolute;
            background: url("./../assets/circle-within.png") no-repeat;
            background-size: 100% 100%;
            width: 63px;
            height: 64px;
            animation: rotate 3s linear infinite;
            @keyframes rotate {
              from {
                transform: rotate(0deg);

              }
              to {
                transform: rotate(360deg);
              }
            }
          }

          .ico {
            background: url("./../assets/water.png") no-repeat;
            background-size: 100% 100%!important;
            width: 38px;
            height: 42px;
          }
        }

        p {
          font-size: 12px;
          color: #b0b0b0;

        }

        .energy-num {
          background: url("./../assets/energy-monitoring.png") no-repeat;
          background-size: 100% 100%;
          width: 77px;
          height: 18vh*.0926;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12.66px;
        }
      }
    }

    .personnel {

      width: 100%;
      padding-left: 7px;
      padding-right: 14px;
      box-sizing: border-box;
      height: 220vh*0.0926;
      margin-top: 8vh*0.0926;
      margin-bottom: 21vh*0.0926;
    }

    .alarm-box {
      width: 100%;
      height: 144vh*0.0926;
      padding: 0 7px;
      box-sizing: border-box;
      margin-top: 13vh*0.0926;
      margin-bottom: 20vh*0.0926;
      .alarm-list {
        li {
          padding-right: 10px;
          margin-top: 12vh*0.0926;
          position: relative;
          .list-top {
            display: flex;
            align-items: center;
            .degree-color{
              width: 8px;/*no*/
              height: 8px;/*no*/
              border-radius: 50%;
              background: #ffa710;
            }
            span{
              &:nth-of-type(1){
                margin-left: 10px;
              }
              &:nth-of-type(2){
                margin-left: 40px;
              }
              &:nth-of-type(3){
                margin-left: 81px;
              }
            }
          }
          .list-bottom {
            display: flex;
            justify-content: space-between;
            margin-top: 5vh*0.0926;
           padding-bottom: 6vh*0.0926;
            span{
              color: #bcbcbc;
              margin-left: 14px;
            }
            p{
              color: #ff0000;
            }
          }
          &:after{
            content: '';
            display: block;
            position: absolute;
            width: 100%;
            height: 1px;
            background: #b0b0b0;
          }
        }
      }
    }
    .monitor{
      margin-top: 10vh*0.0926;
      width: 100%;
      padding: 0 9px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li{
        background: url("./../assets/monitor-box.png") no-repeat;
        background-size: 100% 100%;
        width: 164px;
        height: 117vh*0.0926;
        position: relative;
        &:nth-of-type(1){
          margin-bottom: 10vh*0.0926;
        }
        span{
          display: block;
          margin-left: 2px;
          margin-top: 2px;
        }
        .bg{
          background: url("./../assets/monitor-bg.png") no-repeat;
          background-size: 100% 100%;
          width: 157px;
          height: 96vh*0.0926;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 3%;
          object-fit: fill;
        }
      }
    }
  }
</style>
